module.exports = __webpack_public_path__ + "static/media/logo-comune-negativo.69547f18.jpeg";